<template>
  <div class="form-department-select" @click="handleSelect">
    <x-proxy-form-item
      :showRequired="showRequired"
      :label="widget.label"
      :processTitle="widget.processTitle"
      :validatorRules="validatorRules"
      :validateKey="validateKey"
      :validateInfo="validateInfo"
      :disabled="widget.readOnly">
      <div class="form-department-select-content">
        <x-tag-group
          v-if="renderSence === 'edit'"
          :tags="departmentArray"
          calcKey="name"
          :tagMarginWidth="3"
        ></x-tag-group>
        <template v-else-if="renderSence === 'read'">
          <template v-for="(item, index) in departmentArray">
            <x-tag :key="index" :label="item.name"></x-tag>
          </template>
          <input v-if="departmentArray.length === 0" class="cube-input-field cube-input-field--placeholder" readonly value="-">
        </template>
      </div>
      <input
        v-if="departmentArray.length === 0 && renderSence === 'edit' && !widget.readOnly"
        class="cube-input-field cube-input-field--placeholder"
        readonly
        :value="widget.placeholder"
      />
    </x-proxy-form-item>
    <div class="form-department-select-suffix" :class="{ 'full-height': (validateInfo.validate !== 'error') }" v-if="renderSence === 'edit' && !widget.readOnly"  @click.stop="handleClick">
      <x-svg-icon v-if="departmentArray.length === 0" name="x-lib-arrow-right"></x-svg-icon>
      <x-svg-icon v-else name="x-lib-clear"></x-svg-icon>
    </div>
  </div>
</template>

<script>
import FormWidgetConfigMixin from '../../../mixins/form-widget.mixin'
import XTagGroup from '../../x-tag-group/x-tag-group'
import XTag from '../../x-tag/x-tag'
import {
  mapState,
  mapMutations
} from 'vuex'

export default {
  name: 'FormDepartmentSelect',
  components: {
    XTagGroup,
    XTag
  },
  mixins: [FormWidgetConfigMixin],
  inject: ['$compRouter'],
  data() {
    return {
      compPayloadKey: this.$route.query.key
    }
  },
  computed: {
    ...mapState({
      compPayload: state => state.compRouterModule.compPayload
    }),
    departmentArray() {
      return (this.formValue && this.formValue[0] && this.formValue[0].id) ? this.formValue : []
    },
    formDetailData() {
      return this.compPayload[this.compPayloadKey].formData
    }
  },
  methods: {
    handleSelect() {
      if (!this.widget.readOnly) {
        this.$compRouter.push(this.$options.name, {
          key: this.propKey,
          widgetConfig: this.widget,
          value: (this.formValue && this.formValue[0] && this.formValue[0].id) ? this.formValue : [],
          formData: this.$route.query.inTable ? this.formDetailData : this.formData
        })
      }
    },
    handleClear() {
      this.formValue = []
    },
    handleClick() {
      if (!this.widget.readOnly) {
        if (this.departmentArray.length > 0) {
          this.handleClear()
        } else {
          this.handleSelect()
        }
      }
    }
  }
}
</script>

<style lang="scss">
.form-department-select {
  display: flex;
  align-items: center;
  background-color: $--app-box-bgColor;
  position: relative;
  .x-proxy-form-item {
    // padding-bottom: 0.43rem;
    .x-proxy-form-item-content {
      padding-right: 2.29rem;
    }
  }
  .form-department-select-content {
    display: flex;
    flex-wrap: wrap;
    // margin-top: -0.285rem;
  }
  .form-department-select-suffix {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 3.43rem;
    height: calc(100% - 1.71rem);
    color: $--app-notice-color;
    &.full-height {
      height: 100%;
    }
  }
}
</style>